<template>
    <div
        :id="id"
        class="search-preference__reset"
    >
        <button
            class="pt-ui-btn"
            @click="provider.resetSettings"
        >
            {{ $t('Search.propver.reset') }}
        </button>
        <button
            v-if="showApplyToAll"
            class="pt-ui-btn"
            style="margin-left: 8px"
            @click="provider.applyToAllQueries"
        >
            {{ $t('Search.propver.applyToAll') }}
        </button>
    </div>
</template>

<script>
import snakeCase from 'lodash/snakeCase';

export default {
    inject: ['store', 'provider'],
    props: {
        showApplyToAll: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        id() {
            return [
                'bio_setting',
                this.searchType,
                'reset',
            ].map(snakeCase).join('-');
        },
    },
};
</script>
